/*
 * @Author: Zhouqi
 * @Date: 2025-12-19 18:23:08
 * @LastEditors: Zhouqi
 * @LastEditTime: 2025-12-22 14:25:30
 */
const InputRemoveIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.803 2.80292C3.09589 2.51003 3.57077 2.51003 3.86366 2.80292L7.99999 6.93926L12.1363 2.80292C12.4292 2.51003 12.9041 2.51003 13.197 2.80292C13.4899 3.09582 13.4899 3.57069 13.197 3.86358L9.06066 7.99992L13.197 12.1363C13.4899 12.4291 13.4899 12.904 13.197 13.1969C12.9041 13.4898 12.4292 13.4898 12.1363 13.1969L7.99999 9.06058L3.86366 13.1969C3.57077 13.4898 3.09589 13.4898 2.803 13.1969C2.5101 12.904 2.5101 12.4291 2.803 12.1363L6.93933 7.99992L2.803 3.86358C2.5101 3.57069 2.5101 3.09582 2.803 2.80292Z"
        fill="var(--label-regular, #3C3D3E)"
      />
    </svg>
  );
};
export default InputRemoveIcon;
